module.exports = __webpack_public_path__ + "img/soft_17.437400d9.png";